import styled from "styled-components";

import { colorsPalettes, setFont } from "@similarweb/styles";

import { i18nFilter } from "app/filters/i18nFilter";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const Header = styled.span`
    ${setFont({ $size: 24, $weight: 500, $color: colorsPalettes.carbon[500], $family: "DM Sans" })};
`;

const SectionHeaderContainer = styled(FlexColumn)`
    justify-content: center;
    height: 100%;
`;

const i18n = i18nFilter();

export const SectionHeader = ({ sectionTitleKey }) => {
    return (
        <SectionHeaderContainer>
            <Header>{i18n(sectionTitleKey)}</Header>
        </SectionHeaderContainer>
    );
};
